import { FormattedMessage } from 'react-intl';

import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useReturnErrorContext } from '../../return-error-provider';

export const ErrorInfo = () => {
  const { needsAttention } = useReturnErrorContext();

  if (!needsAttention) return null;

  return <BannerMessageV2 content={<Content />} layout={BannerLayout.Full} status={BannerStatus.Error} />;
};

const Content = () => {
  const { errorMessageDescriptor, errorLabelDescriptor, action, actionText, storeName } = useReturnErrorContext();

  return (
    <>
      <Text textType={TextType.H4} value={<FormattedMessage {...errorLabelDescriptor} />} />
      <Text formattedMessageValues={{ storeName }} textType={TextType.Paragraph} value={errorMessageDescriptor} />

      {action ? (
        <Button onClick={action} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...actionText} />
        </Button>
      ) : null}
    </>
  );
};
